<template>
 <div class="main">
   <!--<section class="page page-subpage">-->
    <!--<vue-simplebar class="page page-subpage">-->
    <transition appear name="turnIn">
    <simplebar class="page page-subpage" data-simplebar-auto-hide="true" v-bind:class="{ 'linkIsClicked' : linkClicked }">

    <!-- <nav class="navigation">
      <ul class="menu menu-rsvp">
        <li><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class="menu menu-left">
        <li><router-link to="/schema">Schema</router-link></li>
        <li><router-link to="/florens">Florens</router-link></li>
      </ul>

      <ul class="menu menu-center">
        <li><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class=" menu menu-right">
        <li class="current"><router-link to="/ceremoni">Ceremoni</router-link></li>
        <li><router-link to="/middag">Middag</router-link></li>
      </ul>
    </nav> -->

    <navigation @link-clicked="linkClickedFunc" v-bind:linkClickedC="linkClicked"></navigation>

    <hr class="page-hr">

    <h1>Ceremoni</h1>

    <figure class="page-ceremoni-img">
      <!--<img src="../assets/davidochfrida.png" width="100%" height="auto" alt="David och Frida"/>-->
      <img src="../assets/terrassen-opt.jpg" width="100%" height="auto" alt="Terrassen"/>
    </figure>

    <p class="page-ingress">Vår vigselceremoni i Florens utförs av officiant <a href="https://tuscanweddingofficiant.com/about/" title="Läs mer om Carina" target="_blank">Carina Pop</a>. Ceremonin är symbolisk och sekulär.</p>

    <hr class="hr-icons"/>

    <h2>När &amp; var</h2>
    <p>Ceremonin börjar kl. 16.00 den 24 juni 2022. Eventet håller som längst på till kl. 19.00. Ceremonin hålls på terrassen tillhörande en av bröllopssviterna på <a href="https://www.hotelsantamarianovella.it/" title="Läs mer på hotellets hemsida" target="_blank">Santa Maria Novella Hotel</a>. I händelse av dåligt väder kommer ceremonin att hållas inomhus.</p>

    <article class="page-ceremony-program">
      <h2>Program</h2>
      <hr class="hr-ornament"/>
      <p>Preludium</p>
      <p>Procession</p>
      <p>Öppningsanförande</p>
      <p>Utbyte av löften</p>
      <p>Utbyte av ringar</p>
      <p>Äktenskapsförklaring</p>
      <p>Avslutning</p>
      <hr class="hr-ornament"/>
    </article><!--page-ceremony-program-->

    <h2>Mat &amp; dryck</h2>
    <p>Direkt efter ceremonin serveras en italiensk buffé med lättare plockmat, samt olika drycker.</p>

    <hr class="hr-icons"/>

    <h2>Klädsel</h2>
    <p>Riktlinje för klädsel är någonstans mellan kavaj och smoking.</p>
    <p>&nbsp;</p>

    <!--</vue-simplebar>-->
    </simplebar>
    </transition>
   <!--</section>page-->
  </div><!--main-->
</template>

<script>

import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css'; //importerar denna som vanlig scss istället med copy paste för att få den inbakad i vanliga css filen

import Navigation from '../components/Nav.vue';

export default {
  name: 'ceremoni',
  components: {
    simplebar,
    Navigation
  },
  data: function () {
    return {
      linkClicked: false
    };
  },

  methods: {
    linkClickedFunc (emittedvalue) {
      this.linkClicked = emittedvalue;
      // console.log('linkClickedFunc kördes');
      return this.linkClicked;
    }
  },
  mounted: function () {
    const pageSubpage = document.getElementsByClassName('page-subpage')[0];
    const pageSubpageHeight = document.getElementsByClassName('page-subpage')[0].offsetHeight + 15;
    // console.log(pageSubpageHeight);

    pageSubpage.style.height = pageSubpageHeight + 'px';
  }
};
</script>